var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import Tooltip from 'rc-tooltip';
import 'rc-tooltip/assets/bootstrap.css';
export var TooltipTopBar = function (_a) {
    var title = _a.title, children = _a.children;
    return (_jsx(Tooltip, __assign({ placement: "bottom", trigger: ['hover'], overlay: _jsx(_Fragment, { children: title }), overlayInnerStyle: {
            backgroundColor: '#353535',
            fontSize: 12,
            padding: '7px 10px',
        }, overlayStyle: {
            opacity: 1,
        } }, { children: _jsx("div", { children: children }) })));
};
export var TooltipSideBar = function (_a) {
    var title = _a.title, children = _a.children;
    return (_jsx(Tooltip, __assign({ placement: "right", trigger: ['hover'], overlay: title, overlayInnerStyle: {
            backgroundColor: '#353535',
            fontSize: 12,
            padding: '7px 10px',
        }, overlayStyle: {
            opacity: 1,
        } }, { children: _jsx("div", __assign({ style: {
                lineHeight: '0',
            } }, { children: children })) })));
};
